export const GBP_REGIONS = ['GB', 'IM', 'JE', 'GI', 'GG', 'GS', 'SH', 'FK'];

export const isGbpRegion = (countryCode: string) => GBP_REGIONS.includes(countryCode);
